const endpoints = {
  GET_SIGNED_URL: {
    url: ({ item }) => {
      const contentId = item?.contentHashId;
      const liveSessionId = item?.liveSessionId;

      let url = "";
      if (liveSessionId) {
        // case for live class session
        url = `/cams/uploader/video/jw-signed-url?liveSessionId=${contentId}`;
        url = `/cams/uploader/video/jw-signed-url?liveSessionId=${contentId}`;
      } else {
        // case for normal video session
        url = `/cams/uploader/video/jw-signed-url?contentId=${contentId}`;
      }

      return url;
    },
    method: "GET",
    params: [],
  },
};
export default endpoints;
